import React, { useState, useEffect } from "react";

function PWAInstallPrompt() {
  const [prompt, setPrompt]     = useState(null);
  const [show, setShow]         = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    // Don't show if already installed as PWA
    if (window.matchMedia("(display-mode: standalone)").matches) return;
    if (localStorage.getItem("pwa_dismissed")) return;

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem("pwa_dismissed", "1");
    setShow(false);
  };

  if (!show || installed) return null;

  return (
    <div style={{
      position:"fixed", bottom:80, left:12, right:12, zIndex:9998,
      background:"linear-gradient(135deg,#1a0033,#2d0055)",
      borderRadius:18, padding:"18px 16px",
      border:"1px solid rgba(139,95,191,0.4)",
      boxShadow:"0 8px 32px rgba(0,0,0,0.8)",
      display:"flex", alignItems:"center", gap:14,
      fontFamily:"DM Sans,sans-serif",
      animation:"slideUpPWA 0.4s ease-out",
    }}>
      {/* Logo */}
      <div style={{ width:52, height:52, borderRadius:14, overflow:"hidden", flexShrink:0, background:"#1a0033", border:"1px solid rgba(139,95,191,0.3)" }}>
        <img src="/logo192.png" alt="IcingShow" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
      </div>

      {/* Text */}
      <div style={{ flex:1, minWidth:0 }}>
        <p style={{ color:"#fff", fontWeight:800, fontSize:15, margin:"0 0 2px" }}>Install IcingShow</p>
        <p style={{ color:"rgba(255,255,255,0.55)", fontSize:12, margin:0, lineHeight:1.4 }}>
          Add to your home screen for the full app experience
        </p>
      </div>

      {/* Buttons */}
      <div style={{ display:"flex", flexDirection:"column", gap:6, flexShrink:0 }}>
        <button onClick={install} style={{
          background:"linear-gradient(135deg,#8B5FBF,#6a3fa0)",
          border:"none", borderRadius:10, padding:"8px 16px",
          color:"#fff", fontWeight:700, fontSize:13,
          cursor:"pointer", fontFamily:"DM Sans,sans-serif",
          whiteSpace:"nowrap",
        }}>
          Install
        </button>
        <button onClick={dismiss} style={{
          background:"none", border:"none",
          color:"rgba(255,255,255,0.35)", fontSize:11,
          cursor:"pointer", fontFamily:"DM Sans,sans-serif",
          textAlign:"center",
        }}>
          Not now
        </button>
      </div>

      <style>{`
        @keyframes slideUpPWA {
          from { transform:translateY(20px); opacity:0; }
          to   { transform:translateY(0);    opacity:1; }
        }
      `}</style>
    </div>
  );
}

export default PWAInstallPrompt;
